import React from 'react'
import {
  Box,
  Popover,
  PopoverArrow,
  PopoverContent,
  PopoverTrigger,
} from '@chakra-ui/react'
import { DOPPEL_DARK_CLICKABLE, DOPPEL_GREY } from '@/utils/style'

type StatsTooltipProps = {
  children: React.ReactNode
}

const TOOLTIP_BG_COLOR = DOPPEL_DARK_CLICKABLE

const StatsTooltip: React.FC<StatsTooltipProps> = ({ children }) => {
  return (
    <Popover arrowSize={15} autoFocus={false} isOpen offset={[0, -4]} placement="top">
      <PopoverTrigger>
        <Box h={1} pointerEvents="none" w={1} />
      </PopoverTrigger>

      <PopoverContent
        bg={TOOLTIP_BG_COLOR}
        borderRadius="md"
        color={DOPPEL_GREY}
        px={3}
        py={2}
        width="inherit"
      >
        <PopoverArrow bg={TOOLTIP_BG_COLOR} />

        {children}
      </PopoverContent>
    </Popover>
  )
}

export default StatsTooltip
